import { useQuery } from '@tanstack/react-query'
import {
  isUserAdminInSociety,
  isUserBoardMemberInSociety,
} from '../../../helpers/society'
import { useAuth } from '../../../hooks/useAuth'
import { societyQueries } from '../../../api/societies'

// Printing is for the board and admins of the post's society only.
export const useCanPrintPost = (
  societyId?: string
): { canPrint: boolean; isLoading: boolean } => {
  const { userId } = useAuth()
  const { data: societies, isLoading } = useQuery(
    societyQueries.getUserSocieties(userId)
  )

  const society = societies?.find((_society) => _society._id === societyId)
  const canPrint =
    !!userId &&
    (isUserAdminInSociety(society, userId) ||
      isUserBoardMemberInSociety(society, userId))

  return { canPrint, isLoading }
}
